import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'eoc.routing-rules.delete-modal.title.no-translate',
		defaultMessage: 'Delete routing rule?',
		description: 'The text will be displayed in the delete modal title.',
	},
	description: {
		id: 'eoc.routing-rules.delete-modal.description.no-translate',
		defaultMessage: `This will permanently delete the routing rule{name, select,
      false {}
      other { "{name}"}
    }. This can’t be undone.`,
		description: 'The text will be displayed in the delete modal description.',
	},
	cancelButton: {
		id: 'eoc.routing-rules.delete-modal.cancel-button.no-translate',
		defaultMessage: 'Cancel',
		description: 'The text will be displayed in the delete modal footer for cancel button.',
	},
	deleteButton: {
		id: 'eoc.routing-rules.delete-modal.delete-button.no-translate',
		defaultMessage: 'Delete',
		description: 'The text will be displayed in the delete modal footer for delete button.',
	},
});
